
export class selectedVitalsList {
    static readonly type = '[selectedVitals] selectedVitals';

    constructor(public payload: any[]) {
    }
}  
// export class DeletedVital {
//     static readonly type = '[DeletedVitals] DeletedVitals';

//     constructor(public payload: any) {
//     }
// }    